// @module BluePoint.LanguageSwitcher.LanguageSwitcher
define('BluePoint.LanguageSwitcher.LanguageSwitcher.View'
,	[
	'bluepoint_languageswitcher_languageswitcher.tpl'
	
	,	'Backbone'
	,	'underscore'
    ]
, function (
	bluepoint_languageswitcher_languageswitcher_tpl
	
	,	Backbone
	,	_
)
{
    'use strict';

	// @class BluePoint.LanguageSwitcher.LanguageSwitcher.View @extends Backbone.View
	return Backbone.View.extend({

		template: bluepoint_languageswitcher_languageswitcher_tpl

	,	initialize: function (options) {
			// this.model = new LanguageSwitcherModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });

			this.environment = options.environment;
			this.languageArray = options.languageArray;
			var langList = this.environment.getConfig('languageswitcher.langlist');
			var currentSession = this.environment.getSession();
			var currentLang = currentSession.language && currentSession.language.locale;
			this.languages = this.environment.getSiteSetting('languages');
			
			console.log("langList", langList);
			console.log("Current Language", currentLang);

			_.each(this.languages, function(lang) {
				lang.isSelected = lang.locale === currentLang;
			});

			var langCodes = langList.map(function(l) {
  				return l.langcode;
			});

			this.filteredArray = this.languages.filter(function(item) {
  				return langCodes.includes(item.locale);
			});			
			console.log("filteredArray", this.filteredArray);
		}

	,	events: {
			'change [data-toggle="lang-selector"]': 'setLang',
			'click [data-toggle="lang-selector"]': 'langSelectorClick',
			'click [data-action="showlanguage"]': 'showlanguageModel',
		}

	,	bindings: {
		}

	, 	childViews: {
		}

	,	showlanguageModel: function(e) {
    		e.preventDefault();
			var dropdown = jQuery('.language-options-container');
    		dropdown.toggle();
		}

	,	langSelectorClick: function(e) {
			e.stopPropagation();
		}

	,	setLang: function setLang(e)
		{
			var selectedLangCode = this.$(e.target).val();
			this.setLanguage(selectedLangCode);
		}

	,	setLanguage: function setLanguage(selectedLangCode)
		{		
			var selected_lang = _.find(SC.ENVIRONMENT.availableLanguages, function(language)
			{
				return language.locale == selectedLangCode;
			});
			var lang = 'lang=' + selected_lang.locale;
			var siteDomain = SC.ENVIRONMENT.siteSettings.touchpoints.home;
			var pathname = window.location.pathname;
			var queryParams = window.location.search;
			var urlparams = new URLSearchParams(queryParams);
			queryParams = '';

			if(urlparams.has('lang'))
			{
				urlparams.delete('lang');
				for (const [key, value] of urlparams.entries()) {
					queryParams += `${key}` + '=' + `${value}`;
				}
			}

			if(queryParams != '')
			{
				queryParams += '&';
			}

			// sessionStorage.setItem("userLang", selected_lang.locale);

			window.location.href = siteDomain + pathname + '?' + queryParams + lang;
		}

		//@method getContext @return BluePoint.LanguageSwitcher.LanguageSwitcher.View.Context
	,	getContext: function getContext()
		{
			return {
				availableLanguages: this.filteredArray,
				showLanguageSelector: (this.filteredArray && this.filteredArray.length > 1) ? true : false
			};
		}
	});
});
